import axios from 'axios';

import {
  getIdDonViFromLocalStorage,
  getMaDonViFromLocalStorage,
  getYearFromLocalStorage,
} from '@/core/helpers/utils';
import {
  AccountantItemResponse,
  ApiResponse,
  PaginationResponseBase,
} from '../interfaces/ApiResponses';

export default class AccountantService {
  static fetch(
    accountCode: string,
    detailCode?: string
  ): Promise<{
    data: ApiResponse<{
      current_page: number;
      data: AccountantItemResponse[];
      first_page_url: string;
      from: number;
      last_page: number;
      last_page_url: string;
      next_page_url: string | null;
      per_page: number;
      prev_page_url: string | null;
      to: number;
      total: number;
    }>;
  }> {
    return axios({
      method: 'GET',
      url: `${
        process.env.VUE_APP_HARACO_GATEWAY_API_URL
      }/tai-khoan/search?matk=${accountCode}&mact=${detailCode}${
        detailCode ? '&query_mact=true' : ''
      }`,
      headers: {
        'X-Authorization': process.env.VUE_APP_API_KEY_1,
        year: getYearFromLocalStorage(),
        madonvi: getMaDonViFromLocalStorage(),
        'X-Tenant-Id': getIdDonViFromLocalStorage(),
      },
    });
  }

  static find({
    ma_tk,
    ma_ct,
    operator,
  }: {
    ma_tk: string;
    ma_ct: string;
    operator: string | null;
  }): Promise<{
    data: ApiResponse<PaginationResponseBase<AccountantItemResponse>>;
  }> {
    return axios({
      method: 'GET',
      url: `${
        process.env.VUE_APP_HARACO_GATEWAY_API_URL
      }/tai-khoan/search?matk=${ma_tk}&mact=${ma_ct}${
        operator ? `&operator=${operator}` : ''
      }${ma_ct ? `&query_mact=true` : ''}`,

      headers: {
        'X-Authorization': process.env.VUE_APP_API_KEY_1,
        year: getYearFromLocalStorage(),
        madonvi: getMaDonViFromLocalStorage(),
      },
    });
  }
}
